var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 35 35"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#fff",
    transform: "rotate(90 17.5 17.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FC470E",
    d: "m17.906 22.235 3.632-2.923c.277-.242.303-.63.09-.884a.68.68 0 0 0-.904-.088l-2.584 2.082v-7.864a.634.634 0 0 0-.641-.626c-.354 0-.641.28-.641.626v7.863l-2.584-2.082c-.26-.208-.685-.161-.905.088-.226.258-.17.676.09.884l3.632 2.924c.274.19.55.174.815 0"
  })));
};
export default SvgArrowDown;